import type { ReactNode } from "react";
import { Link } from "react-router";
import { BrandMark } from "../../components/BrandMark";
import { RecipeArt } from "../../components/RecipeArt";

/** Shared frame for sign-in, registration, verification and reset screens. */
export function AuthLayout({ title, lead, children, footer }: { title: string; lead?: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="auth">
      <div className="auth__wall" aria-hidden="true">
        <div className="auth__plates">
          <RecipeArt seed="auth-bowl" title="Tomato soup" className="auth__plate auth__plate--a" />
          <RecipeArt seed="auth-loaf" title="Honey loaf" className="auth__plate auth__plate--b" />
          <RecipeArt seed="auth-leaf" title="Garden salad" className="auth__plate auth__plate--c" />
        </div>
        <p className="auth__tagline">Recipes, groceries, pantry and the week's meals — kept together for everyone in your kitchen.</p>
      </div>
      <main className="auth__main" id="main">
        <Link to="/" className="brand auth__brand">
          <BrandMark />
          <span className="brand__word">Supperkeep</span>
        </Link>
        <section className="auth-card" aria-labelledby="auth-title">
          <h1 className="auth-title" id="auth-title">
            {title}
          </h1>
          {lead ? <div className="auth-lead">{lead}</div> : null}
          {children}
        </section>
        {footer ? <div className="auth__footer">{footer}</div> : null}
      </main>
    </div>
  );
}
